/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import Grid from "@mui/material/Grid";
import PopAddBasic from "./PopAddBasic";
import MDBox from "components/MDBox";
import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "components/custom/Loader";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import Divider from "@mui/material/Divider";

import {
  Card,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
  Avatar,
} from "@mui/material";
import MDTypography from "components/MDTypography";
import { MaterialReactTable } from "material-react-table";
import { useMaterialUIController } from "context";
import "../SignIn/SignIn.css";
import IconButton from "@mui/material/IconButton";
import MapComponent from "./components/MapComponent";
import { useSnackbar } from "notistack";
import LaunchIcon from "@mui/icons-material/Launch";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import { Tag } from "antd";
import "./Somecss.css";
import useApiRequest from "utils/Apirequest";
import { AutoTooltip } from "utils/Constant";
import { handleSignout } from "utils/Logout";
import { getDecodedUserData } from "utils/Constant";
import Unresolved from "../../assets/cms-icons/unresolved.png";

function Location_mgmt() {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { sidenavColor } = controller;
  const [isLoading, setIsLoading] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  const [totalChargers, setTotalChargers] = useState(0);

  const locationTypes = [
    "Parking Garages",
    "Office Complexes",
    "Petrol Pumps",
    "Malls",
    "Highways",
    "Resorts",
    "Airports",
    "Hotels",
    "Supermarkets",
    "Train Stations",
    "Restaurants",
    "Residential Areas",
    "Parks and Recreational Areas",
    "University Campuses",
    "Convention Centers",
    "Stadiums and Sports Arenas",
    "Movie Theaters",
    "Hospitals",
    "Government Buildings",
    "Libraries",
    "Community Centers",
    "Beach Parking Lots",
    "Tourist Attractions",
    "Car Dealerships",
    "Metro Stations",
  ];

  const initialLocations = locationTypes.map((type, index) => ({
    id: index + 1,
    count: 0,
    locationType: type,
    percentage: 0,
  }));

  const [locations, setLocations] = useState([]);
  const [items, setItems] = useState(initialLocations);
  const [showAllCards, setShowAllCards] = useState(false);

  const handleLocationTypes = () => {
    axios({
      method: "get",
      url:
        process.env.REACT_APP_BASEURL + "charger-locations/location-type-count",
      withCredentials: true,

    })
      .then((response) => {
        if (response.data.success === true) {
          const updatedData = response.data.data.map((item, index) => ({
            ...item,
            id: index + 1,
          }));

          const mergedItems = items.map((item) => {
            const match = updatedData.find(
              (update) => update.locationType === item.locationType
            );
            return match
              ? { ...item, count: match.count, percentage: match.percentage }
              : item;
          });

          setItems(mergedItems);
        } else {
          enqueueSnackbar(response.data.message, { variant: "error" });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.message, { variant: "error" });
        if (error?.response?.status === 401) {
          handleSignout();
        }
      });
  };

  const statusList = [
    "Incomplete",
    "Inactive",
    "Active",
    "Pending",
    "Waitlisted",
  ];

  const getValues = () => {
    return {
      locationName: "",
      locationType: "",
      address: "",
      state: "",
      city: "",
      status: "Active",
      freepaid: {
        parking: true,
        charging: true,
      },
      parkingCost: {
        amount: "",
        currency: process.env.REACT_APP_CURRENCYCODE,
      },
      direction: {},
      chargerInfo: [{}],
      facilities: [],
      workingDays: "Everyday",
      slots: [],
      salesManager: { name: "", phoneNumber: "", email: "" },
      dealer: { name: "", phoneNumber: "", email: "" },
      locationImage: [],
    };
  };
  useEffect(() => {
    if (getDecodedUserData()?.login_status !== "true") {
      navigate("/sign-in");
    }
    axios({
      method: "get",
      url: process.env.REACT_APP_BASEURL + "charger-locations",
      withCredentials: true,

    })
      .then((response) => {

        if (response.data.success === true) {
          const element = [];
          const dataWithChargerCount = response.data.data.map((location) => {
            const availCount = location.chargerInfo.filter(
              (charger) => charger.status === "Active"
            ).length;
            const inuseCount = location.chargerInfo.filter(
              (charger) => charger.status === "Inuse"
            ).length;
            const inactiveCount = location.chargerInfo.filter(
              (charger) => charger.status === "Inactive"
            ).length;
            const ele = {
              name: location.locationName,
              direction: location.direction,
              availCount: availCount,
              inuseCount: inuseCount,
              inactiveCount: inactiveCount,
              data: location,
            };
            element.push(ele);
            const acCount = location.chargerInfo.filter(
              (charger) => charger.type === "AC"
            ).length;
            const dcCount = location.chargerInfo.filter(
              (charger) => charger.type === "DC"
            ).length;
            const energyDisp =
              location.chargerInfo
                .reduce((total, charger) => {
                  const energyValue = parseFloat(
                    charger?.energyConsumptions?.replace(" kWh", "")
                  );
                  return total + energyValue;
                }, 0)
                .toFixed(2) + " kWh";
            const chargerInfoRep = location.chargerInfo.map((charger) => ({
              locationType: charger.powerOutput,
              chargers: charger.subtype,
              locationName: charger.name,
              energy_disp: charger.energyConsumptions,
              status:
                ["Charging", "Available", "Preparing"].includes(
                  charger?.connectors?.[0]?.status
                ) ||
                  ["Charging", "Available", "Preparing"].includes(
                    charger?.connectors?.[1]?.status
                  )
                  ? "Available"
                  : "Inactive",

              c_type: charger.type,
            }));
            return {
              ...location,
              energy_disp: energyDisp,
              chargers: location.chargerInfo.length,
              c_type: `AC: ${acCount}, DC: ${dcCount}`,
              chargerInfoRep: chargerInfoRep,
            };
          });
          setLocations(element);
          setRows(dataWithChargerCount);
          const totalCharger = dataWithChargerCount.reduce((sum, item) => {
            return sum + (item.chargers || item.chargerInfo?.length || 0);
          }, 0);

          setTotalChargers(totalCharger);
          setIsLoading(false);

        } else {
          enqueueSnackbar(response.data.message, { variant: "error" });
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        if (error?.response?.status === 401) {
          handleSignout();
        }
      });
    handleLocationTypes();
  }, []);


  const [values, setValues] = useState(getValues);
  const [isDisabled2, setIsDisabled2] = useState(false);
  const [mapDisabled, setMapDisabled] = useState(true);
  const [columns, setColumns] = useState([]);

  const [rows, setRows] = useState([]);
  const apiRequest = useApiRequest();

  const handleActive = async (row_data) => {
    const payload = {
      status: "Active",
    };
    const { data } =
      (await apiRequest(
        "PUT",
        "charger-locations/" + row_data?._id,
        payload,
        {},
        {}
      )) || {};
    if (data?.success === true) {
      window.location.reload();
    }
  };

  const column = useMemo(
    () => [
      {
        header: "Status",
        filterVariant: "select",
        filterSelectOptions: statusList,
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        accessorKey: "status",
        align: "center",
        fixed: "true",
        filterFn: (row, id, columnFilterValue) => {
          if (row.original.status === "Incomplete") {
            return false;
          }
          if (columnFilterValue === "Incomplete") {
            return row.original.status !== "Active";
          }
          return row.original.status === columnFilterValue;
        },
        Cell: (row) => (
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            borderRadius="md"
            bgcolor="rgba(25, 128, 56, 0.2)"
            style={{
              flex: 1,
            }}
          >
            <Tag
              color={
                row.row.original.status === "Inactive"
                  ? "red"
                  : row.row.original.status === "Waitlisted"
                    ? "default"
                    : row.row.original.status === "Pending"
                      ? "yellow"
                      : row.row.original.status === "Active"
                        ? "green"
                        : "yellow"
              }
            >
              {row.row.original.status}
            </Tag>
          </MDBox>
        ),
      },
      {
        header: "Name",
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
        accessorKey: "locationName",
        align: "center",

        Cell: ({ row }) => {
          const locationName = row?.original?.locationName ?? "N/A";
          const isSubRow = row.depth > 0;
          if (isSubRow) {
            return <AutoTooltip maxWidth={150}><span>{locationName}</span></AutoTooltip>;
          }

          return (
            <AutoTooltip maxWidth={150}><span
              onClick={(e) => handleView(row?.original)}
              style={{
                color: '#1E88E5',
                cursor: 'pointer',
                textDecoration: 'underline',
              }}
            >
              {locationName}
            </span>
            </AutoTooltip>
          );
        },
      }
      ,
      {
        header: "L Type", muiTableHeadCellProps: {
          align: 'center',
        },
        muiTableBodyCellProps: {
          align: 'center',
        }, accessorKey: "locationType", align: "center",
        Cell: ({ cell }) => {
          const l_type = cell.getValue() || ' ';
          return <AutoTooltip maxWidth={150}>{l_type}</AutoTooltip>;
        }

      },
      {
        header: "City", muiTableHeadCellProps: {
          align: 'center',
        },
        muiTableBodyCellProps: {
          align: 'center',
        }, accessorKey: "city", align: "center",
        Cell: ({ cell }) => {
          const city = cell.getValue() || ' ';
          return <AutoTooltip maxWidth={150}>{city}</AutoTooltip>;
        }
      },
      {
        header: "State", muiTableHeadCellProps: {
          align: 'center',
        },
        muiTableBodyCellProps: {
          align: 'center',
        }, accessorKey: "state", align: "center",
        Cell: ({ cell }) => {
          const state = cell.getValue() || ' ';
          return <AutoTooltip maxWidth={150}>{state}</AutoTooltip>;
        }
      },
      {
        header: "Total Chargers",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        accessorKey: "chargers",
        align: "center",
      },

      {
        header: "Status Count",
        accessorKey: "statusCount",
        enableColumnFilter: false,
        id: "statusCount",
        align: "center",
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
        Cell: ({ row }) => {
          const active = row.original.chargerInfo?.filter(c => c.status === "Active").length || 0;
          const inactive = row.original.chargerInfo?.filter(c => c.status === "Inactive").length || 0;
          const faulty = row.original.chargerInfo?.filter(c => c.status === "Faulty").length || 0;

          return `${active} Active, ${inactive} Inactive, ${faulty} Faulty`;
        },
      },
      {
        header: "Energy disperse",
        accessorKey: "energy_disp",
        align: "center",
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },

        Cell: ({ cell }) => {
          const raw = cell.getValue();
          const num = parseFloat(String(raw).replace(/[^\d.-]/g, "")) || 0;
          if (num >= 1000) {
            return `${(num / 1000).toFixed(2)} MWh`;
          }
          return `${num.toFixed(2)} kWh`;
        },
      },
      {
        header: "Action",
        enableColumnFilter: false,
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        accessorKey: "action",
        align: "center",
        Cell: ({ row }) => {
          const [anchorEl, setAnchorEl] = useState(null);
          const open = Boolean(anchorEl);

          const handleClick = (event) => setAnchorEl(event.currentTarget);
          const handleClose = () => setAnchorEl(null);

          const handleAction = (action) => {
            action();
            handleClose();
          };

          return (
            <div>
              <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? "long-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                onClick={handleClick}
              >
                <MoreVertIcon />
              </IconButton>

              <Menu
                id="long-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
              >
                {/* Menu Item for "View" */}
                <MenuItem
                  onClick={() => handleAction(() => handleView(row?.original))}
                >
                  <ListItemIcon>
                    <LaunchIcon fontSize="small" />
                  </ListItemIcon>
                  <Typography variant="inherit">View Location</Typography>
                </MenuItem>
                <Divider
                  sx={{
                    my: 0.5,
                    borderColor: "rgba(0,0,0,0.08)",
                  }}
                />

                <MenuItem
                  onClick={() => handleAction(() => handleEdit(row?.original))}
                >
                  <ListItemIcon>
                    <EditIcon fontSize="small" />
                  </ListItemIcon>
                  <Typography variant="inherit">Edit Location</Typography>
                </MenuItem>
                <Divider
                  sx={{
                    my: 0.5,
                    borderColor: "rgba(0,0,0,0.08)",
                  }}
                />

                {row?.original?.status !== "Inactive" && (
                  <MenuItem
                    onClick={() => {
                      handleAction(() => handleDelete(row?.original));
                    }}
                  >
                    <ListItemIcon>
                      <DeleteIcon fontSize="small" />
                    </ListItemIcon>
                    <Typography variant="inherit">Mark as Inactive</Typography>
                  </MenuItem>
                )}

                {row?.original?.status !== "Active" && (
                  <MenuItem
                    onClick={() => {
                      handleAction(() => handleActive(row?.original));
                    }}
                  >
                    <ListItemIcon>
                      <img
                        src={Unresolved}
                        alt="Resolved"
                        style={{
                          width: "20px",
                          height: "20px",

                          filter: "brightness(0) invert(0.6)",
                        }}
                      />
                    </ListItemIcon>
                    <Typography variant="inherit">Mark as Active</Typography>
                  </MenuItem>
                )}
              </Menu>
            </div>
          );
        },
      },
    ],
    [sidenavColor]
  );

  useEffect(() => {
    setColumns(column);
  }, [sidenavColor]);

  const navigate = useNavigate();
  useEffect(() => {
    if (getDecodedUserData()?.login_status !== "true") {
      navigate("/sign-in");
    }
  }, []);

  const handleView = (row_data) => {
    navigate("/location/view", { state: row_data?._id });
  };

  const handleEdit = (row_data) => {
    navigate("/location/edit", { state: row_data });
  };

  const handleDelete = (row_data) => {
    const payload = { status: "Inactive" };
    axios({
      method: "post",
      url: process.env.REACT_APP_BASEURL + "charger-locations/" + row_data._id,
      data: payload,
      withCredentials: true,

    })
      .then((response) => {
        if (response?.data?.success === true) {
          enqueueSnackbar(response.data.message, { variant: "success" });
          navigate("/location");
        } else {
          enqueueSnackbar(response.data.message, { variant: "error" });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error?.message, { variant: "error" });
        if (error?.response?.status === 401) {
          handleSignout();
        }
      });
  };

  const handleStateChange = (newState) => {
    setIsDisabled2(newState);
  };
  const handleChange = (event) => {
    setValues((prevValues) => ({
      ...prevValues,
      [event.target.name]: event.target.value,
    }));
  };

  const SubRow = ({ row }) => {
    return (
      <Card elevation={3} variant="outlined" sx={{ p: 2 }}>
        <MDTypography variant="subtitle1" fontWeight="bold" mb={1}>
          Charger Info:
        </MDTypography>
        <Grid container spacing={1}>
          {row.original.chargerInfo.map((charger, index) => (
            <Grid item xs={12} key={index}>
              <MDTypography variant="body2">
                ID: {charger.id}, Type: {charger.type}, Energy Consumption:{" "}
                {charger.energyCons}
              </MDTypography>
            </Grid>
          ))}
        </Grid>
      </Card>
    );
  };

  useEffect(() => {
    if (!navigator.geolocation) {
      console.log("Geolocation is not supported by your browser");
      setMapDisabled(true);
      return;
    }

    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: "geolocation" }).then((result) => {
        if (result.state === "granted") {
          setMapDisabled(false);
        } else if (result.state === "denied") {
          setMapDisabled(true);
        } else if (result.state === "prompt") {
          setMapDisabled(true);
        }

        result.onchange = () => {
          if (result.state === "granted") {
            setMapDisabled(false);
          } else {
            setMapDisabled(true);
          }
        };
      });
    } else {
      navigator.geolocation.getCurrentPosition(
        () => setMapDisabled(false),
        () => setMapDisabled(true)
      );
    }
  }, []);

  return (
    <DashboardLayout>
      <PopAddBasic
        isDialog={isDisabled2}
        onClose={setIsDisabled2}
        value={values}
        onStateChange={handleStateChange}
        onHandleChange={handleChange}
      />
      <DashboardNavbar />
      <MDBox py={3} mt={0}>
        <MDBox mb={4}>
          <MDBox
            mb={3}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexWrap="wrap"
            gap={2}
          >
            <MDBox>
              <MDTypography variant="h4" fontWeight="bold" mb={0.5}>
                Location Types Overview
              </MDTypography>
              <MDTypography variant="body2" color="text" sx={{ opacity: 0.6 }}>
                Manage and monitor all location types across your network
              </MDTypography>
            </MDBox>

          </MDBox>
          <Grid container spacing={3}>
            {(showAllCards
              ? items.filter((item) => item.count > 0)
              : items.filter((item) => item.count > 0).slice(0, 4)
            ).map((item, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={item.id}>
                <Card
                  sx={{
                    height: "100%",
                    boxShadow: darkMode
                      ? "0 4px 12px rgba(0,0,0,0.3)"
                      : "0 4px 12px rgba(0,0,0,0.1)",
                    borderRadius: "16px",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    border: "1px solid",
                    borderColor: darkMode
                      ? "rgba(255,255,255,0.1)"
                      : "rgba(0,0,0,0.08)",
                    background: darkMode
                      ? "linear-gradient(135deg, rgba(32, 41, 64, 0.95) 0%, rgba(32, 41, 64, 1) 100%)"
                      : "linear-gradient(135deg, #ffffff 0%, #fafafa 100%)",
                    "&:hover": {
                      transform: "translateY(-8px)",
                      boxShadow:
                        item.count > 0
                          ? darkMode
                            ? "0 12px 24px rgba(239, 0, 0, 0.3)"
                            : "0 12px 24px rgba(239, 0, 0, 0.2)"
                          : darkMode
                            ? "0 12px 24px rgba(0,0,0,0.4)"
                            : "0 12px 24px rgba(0,0,0,0.15)",
                      borderColor:
                        item.count > 0
                          ? "#ef0000"
                          : darkMode
                            ? "rgba(255,255,255,0.2)"
                            : "rgba(0,0,0,0.15)",
                    },
                  }}
                >
                  <MDBox p={3}>
                    {/* Header with Icon and Badge */}
                    <MDBox
                      display="flex"
                      justifyContent="space-between"
                      alignItems="flex-start"
                      mb={2.5}
                    >
                      <MDBox
                        sx={{
                          background:
                            item.count > 0
                              ? "linear-gradient(195deg, #ef0000, #ef0000)"
                              : darkMode
                                ? "rgba(255,255,255,0.08)"
                                : "rgba(0,0,0,0.05)",
                          borderRadius: "12px",
                          padding: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow:
                            item.count > 0
                              ? "0 4px 12px rgba(239, 0, 0, 0.3)"
                              : "none",
                        }}
                      >
                        <Avatar
                          src={`/locationIcon/${item.locationType}.png`}
                          alt={item.locationType}
                          variant="square"
                          sx={{
                            width: 32,
                            height: 32,
                            backgroundColor: "transparent",
                          }}
                        />
                      </MDBox>
                      <MDBox
                        sx={{
                          backgroundColor: darkMode
                            ? "rgba(255,255,255,0.08)"
                            : "rgba(0,0,0,0.05)",
                          borderRadius: "8px",
                          padding: "4px 8px",
                          minWidth: "32px",
                          textAlign: "center",
                        }}
                      >
                        <MDTypography
                          variant="caption"
                          fontWeight="bold"
                          sx={{
                            fontSize: "0.7rem",
                            color: darkMode
                              ? "rgba(255,255,255,0.6)"
                              : "rgba(0,0,0,0.5)",
                          }}
                        >
                          #{index + 1 < 10 ? `0${index + 1}` : index + 1}
                        </MDTypography>
                      </MDBox>
                    </MDBox>

                    {/* Location Type Name */}
                    <MDTypography
                      variant="h6"
                      fontWeight="bold"
                      sx={{
                        fontSize: "1rem",
                        mb: 2.5,
                        minHeight: "48px",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        lineHeight: 1.4,
                      }}
                    >
                      {item.locationType === "Stadiums and Sports Arenas"
                        ? "Sports Arenas"
                        : item.locationType === "Parks and Recreational Areas"
                          ? "Parks & Recreational"
                          : item.locationType
                      }
                    </MDTypography >

                    {/* Stats Section */}
                    < MDBox
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{
                        pt: 2,
                        mt: 2,
                        borderTop: "2px solid",
                        borderColor: darkMode
                          ? "rgba(255,255,255,0.1)"
                          : "rgba(0,0,0,0.08)",
                      }}
                    >
                      {/* Count */}
                      < MDBox >
                        <MDTypography
                          variant="caption"
                          sx={{
                            fontSize: "0.65rem",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            opacity: 0.7,
                            display: "block",
                            mb: 0.5,
                          }}
                        >
                          Locations
                        </MDTypography>
                        <MDTypography
                          variant="h4"
                          fontWeight="bold"
                          sx={{
                            fontSize: "2rem",
                            color:
                              item.count > 0
                                ? "#ef0000"
                                : darkMode
                                  ? "rgba(255,255,255,0.5)"
                                  : "rgba(0,0,0,0.3)",
                          }}
                        >
                          {item.count}
                        </MDTypography>
                      </MDBox >

                      {/* Percentage Badge */}
                      < MDBox
                        sx={{
                          background:
                            item.percentage > 0
                              ? "linear-gradient(195deg, #ef0000, #ef0000)"
                              : darkMode
                                ? "rgba(255,255,255,0.08)"
                                : "rgba(0,0,0,0.05)",
                          borderRadius: "10px",
                          padding: "8px 16px",
                          boxShadow:
                            item.percentage > 0
                              ? "0 2px 8px rgba(239, 0, 0, 0.3)"
                              : "none",
                        }}
                      >
                        <MDTypography
                          variant="button"
                          fontWeight="bold"
                          sx={{
                            fontSize: "0.875rem",
                            color:
                              item.percentage > 0
                                ? "#ffffff"
                                : darkMode
                                  ? "rgba(255,255,255,0.5)"
                                  : "rgba(0,0,0,0.4)",
                          }}
                        >
                          {item.percentage}%
                        </MDTypography>
                      </MDBox >
                    </MDBox >
                  </MDBox >
                </Card >
              </Grid >
            ))}
          </Grid >

    
        </MDBox >

        {/* Map Section */}
        < MDBox mt={6} >
          <Card
            sx={{
              boxShadow: darkMode
                ? "0 4px 12px rgba(0,0,0,0.3)"
                : "0 4px 12px rgba(0,0,0,0.1)",
              borderRadius: "16px",
              overflow: "hidden",
              border: "1px solid",
              borderColor: darkMode
                ? "rgba(255,255,255,0.1)"
                : "rgba(0,0,0,0.08)",
            }}
          >
            <MDBox
              py={3}
              px={3}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                background: darkMode
                  ? "linear-gradient(135deg, rgba(32, 41, 64, 0.95) 0%, rgba(32, 41, 64, 1) 100%)"
                  : "linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%)",
                borderBottom: "2px solid",
                borderColor: darkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.08)",
              }}
            >
              <MDBox>
                <MDTypography variant="h5" fontWeight="bold" mb={0.5}>
                  Locations Map
                </MDTypography>
                <MDTypography variant="caption" color="text" sx={{ opacity: 0.6 }}>
                  Interactive map showing all charging locations
                </MDTypography>
              </MDBox>

              <MDBox display="flex" alignItems="center" gap={2}>
                <MDBox
                  sx={{
                    background: "linear-gradient(195deg, #ef0000, #ef0000)",
                    borderRadius: "10px",
                    padding: "8px 16px",
                    boxShadow: "0 2px 8px rgba(239, 0, 0, 0.3)",
                  }}
                >
                  <MDTypography variant="button" fontWeight="bold" sx={{ color: "#ffffff" }}>
                    {totalChargers} Chargers
                  </MDTypography>
                </MDBox>

                <MDBox
                  sx={{
                    background: "linear-gradient(195deg, #ef0000, #ef0000)",
                    borderRadius: "10px",
                    padding: "8px 16px",
                    boxShadow: "0 2px 8px rgba(239, 0, 0, 0.3)",
                  }}
                >
                  <MDTypography variant="button" fontWeight="bold" sx={{ color: "#ffffff" }}>
                    {locations.length} Locations
                  </MDTypography>
                </MDBox>
              </MDBox>
            </MDBox>

            <MDBox p={3}>
              <MapComponent locations={locations} />
            </MDBox>
          </Card>
        </MDBox >

        {/* All Locations Table */}
        < MDBox mt={6} >
          <Card
            sx={{
              boxShadow: darkMode
                ? "0 4px 12px rgba(0,0,0,0.3)"
                : "0 4px 12px rgba(0,0,0,0.1)",
              borderRadius: "16px",
              border: "1px solid",
              borderColor: darkMode
                ? "rgba(255,255,255,0.1)"
                : "rgba(0,0,0,0.08)",
            }}
          >
            <MDBox
              mx={2}
              mt={-3}
              py={1}
              px={2}
              variant="gradient"
              bgColor={sidenavColor}
              borderRadius="lg"
              coloredShadow="info"
            >
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  All Locations
                </MDTypography>
                <MDButton
                  onClick={() => setIsDisabled2(!isDisabled2)}
                  variant="outlined"
                  color="white"
                  size="small"
                  disabled={mapDisabled}
                >
                  Add Locations
                </MDButton>
              </Grid>
            </MDBox>
            {isLoading ? (
              <Loader />
            ) : (
              <MaterialReactTable
                id="tble"
                columns={columns}
                data={rows}
                initialState={{ showColumnFilters: false, columnVisibility: { status: false, locationType: false, city: false, state: false, energy_disp: false, action: false } }}
                enableColumnResizing
                columnResizeMode="onChange"
                defaultColumn={{
                  minSize: 100,
                  size: 200,
                  maxSize: 400,
                }}

                muiTableContainerProps={{
                  id: "tble",
                }}
                muiTableProps={{
                  sx: darkMode
                    ? {
                      backgroundColor: "#202940",
                      color: "#ffffff",
                      "& td": {
                        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                        fontSize: "14px",
                        fontWeight: "500",
                        padding: 0,
                        color: "#ffffff",
                      },
                    }
                    : {
                      "& td": {
                        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                        fontSize: "14px",
                        fontWeight: "500",
                        padding: 0,
                        backgroundColor: "#f5f5f5",
                      },
                    },
                }}
                muiTopToolbarProps={{
                  sx: darkMode
                    ? {
                      color: "#ffffff",
                      "& svg": {
                        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                        fontSize: "14px",
                        fontWeight: "500",
                        padding: 0,
                        color: "#ffffff",
                      },
                    }
                    : {
                      backgroundColor: "#f5f5f5",
                    },
                }}
                muiTableHeadCellProps={{
                  sx: darkMode
                    ? {
                      color: "#ffffff",
                      "& svg": {
                        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                        fontSize: "14px",
                        fontWeight: "500",
                        padding: 0,
                        color: "#ffffff",
                      },
                    }
                    : {
                      backgroundColor: "#f5f5f5",
                    },
                }}
                muiBottomToolbarProps={{
                  sx: darkMode
                    ? {
                      color: "#ffffff",
                      "& p,button,div": {
                        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',

                        fontWeight: "500",
                        padding: 0,
                        color: "#ffffff",
                      },
                    }
                    : {
                      backgroundColor: "#f5f5f5",
                    },
                }}
                muiTableBodyCellProps={{
                  sx: {
                    borderBottom: "2px solid #e0e0e0",
                  },
                }}
              />
            )}
          </Card>
        </MDBox >
      </MDBox >
    </DashboardLayout >
  );
}

export default Location_mgmt;
